import { get } from 'lodash';
import React, { FC } from 'react';
import MUIDownloadFile from '../../../../../../../components/ui-component/form-component/form-fields/fields/MUIDownloadFile';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { getUserJwt } from '../../../../../../../context/AuthHelper';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { STRAPI_URL } from '../../../../../../../lib/constants/url';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import AntragSchema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const Ablehnungsbescheid: FC<{}> = () => {
    const { application } = useApplication();
    const bescheidPath = P.Status_Ablehnungsbescheid.path;
    const bescheidDownloadOnPath = P.Zuwendungsvertarg_Unterschrieben_Am.path;

    const handleDownloadBescheid = async () => {
        await fetchFile(get(application, `${bescheidPath}.attributes.url`), get(application, `${bescheidPath}.attributes.name`));
    };

    return (
        <>
            <ApplicationHeading title='Ablehnungsbescheid' description={PLATZHALTER_TEXT} />

            <MUIDownloadFile
                fileMetaData={get(application, bescheidPath, {})}
                onDownload={handleDownloadBescheid}
                downloadedOn={get(application, bescheidDownloadOnPath, null)}
                showDownloadButton={true}
                showDownloadedOn={false}
            />            
        </>
    );
};

export default Ablehnungsbescheid;


const fetchFile = async (url: string, fileName: string = '') => {
    try {
        let res = await fetch(`${STRAPI_URL}${url}`, {
            headers: {
                Authorization: `Bearer ${getUserJwt()}`,
            },
        });

        const blob = await res.blob();
        const objectUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(objectUrl);
    } catch (err: any) {
        console.error(' ERROR: Downloading File ', err);
    }
};
